import React from 'react';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import LabelWorkflowTable from './LabelWorkflowTable';
import LabelBasicTable from './LabelBasicTable';

const LabelOverview: React.FC = () => {
    const {
        state: { project },
    } = useProjectDetailsContext();

    if (!project) return null;

    return (
        <div
            className="centred-max-width-1100"
            // className={
            //     project.workflow.stages.length === 0
            //         ? 'centred-max-width-1100'
            //         : ''
            // }
        >
            <h2>Labels</h2>
            {project.workflow.stages.length === 0 ? (
                <LabelBasicTable />
            ) : (
                <LabelWorkflowTable />
            )}
        </div>
    );
};

export default LabelOverview;
